export default __webpack_public_path__ + "static/media/Tap_placement-19.9e81cde2.png";